import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import CustomLink from 'components/CustomLink';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const FilterButton = forwardRef(
	(
		{
			className,
			icon,
			iconClassName,
			iconWrapperClassName,
			marker,
			onClick,
			reverse,
			style,
			theme,
			title,
			titleClassName,
			tooltip,
			url,
			...props
		},
		ref
	) => {
		const filterClassName = cx(
			styles.button,
			styles[theme],
			styles[`marker_${marker}`],
			{
				[styles.reverse]: reverse
			},
			className
		);
		return url ? (
			<CustomLink
				ref={ref}
				href={url}
				className={cx(filterClassName, styles.link)}
				iconWrapperClassName={cx(styles.iconWrapper, iconWrapperClassName)}
				style={style}
				iconClassName={cx(styles.icon, iconClassName)}
				{...props}
			/>
		) : (
			<button
				type="button"
				ref={ref}
				className={filterClassName}
				style={style}
				title={tooltip}
				onClick={onClick}
				{...props}
			>
				{icon && (
					<span className={cx(styles.iconWrapper, iconWrapperClassName)}>
						<Icon icon={icon} className={cx(styles.icon, iconClassName)} />
					</span>
				)}
				<span className={cx(styles.title, titleClassName)}>{title}</span>
			</button>
		);
	}
);

FilterButton.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.string,
	iconClassName: PropTypes.string,
	iconWrapperClassName: PropTypes.string,
	marker: PropTypes.oneOf(['up', 'down', true]),
	onClick: PropTypes.func,
	reverse: PropTypes.bool,
	style: PropTypes.object,
	theme: PropTypes.oneOf(['bright', 'simpleShape', 'classicField', 'clear']),
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
		PropTypes.object
	]),
	titleClassName: PropTypes.string,
	tooltip: PropTypes.string,
	url: PropTypes.string
};

export default FilterButton;
